import {DisplayCommand, ShowKey, ShowSlideshow} from "../../javaTypes";
import {DisplayConfig} from "../Config";
import {StatelessSponsors, useSponsors} from "./Sponsors";
import {getPages, StatelessKey} from "./AudienceKey";
import {useSlides} from "../util";
import WifiReminder from "./WifiReminder";
import SafetySecurity from "./SafetySecurity";
import Primary from "../layouts/Primary";

export default function Slideshow({config, sponsorsUrl, nowCallback} : {
    config: DisplayConfig,
    sponsorsUrl?: string,
    nowCallback: () => number
}) {
    const chunkedSponsors = useSponsors(sponsorsUrl)
    const keyPages = getPages(config)

    // Rotation order: sponsors, wifi reminder, audience key, safety & security
    const currentSlide = useSlides(chunkedSponsors.length + 1 + keyPages.length + 1)
    const maxSponsorSlide = chunkedSponsors.length - 1
    const wifiSlide = maxSponsorSlide + 1
    const minKeySlide = wifiSlide + 1
    const maxKeySlide = minKeySlide + keyPages.length - 1
    const safetySecuritySlide = maxKeySlide + 1

    if(currentSlide <= maxSponsorSlide) {
        return <StatelessSponsors sponsors={chunkedSponsors[currentSlide]} />
    } else if(currentSlide == wifiSlide) {
        return <WifiReminder />
    } else if(currentSlide <= maxKeySlide) {
        return <StatelessKey isSingleTeam={false} config={config} nowCallback={nowCallback} phase={keyPages[currentSlide - minKeySlide]}/>
    } else if(currentSlide == safetySecuritySlide) {
        return <SafetySecurity />
    } else {
        return <Primary>
            Unknown slide
        </Primary>
    }
}